const MuiRadio = {
  root: {
    color: '#E0E0E0',
  },
};

export default MuiRadio;
